import { PluginObject } from 'vue';
import i18n from '@/plugins/i18n';

export const DatePlugin:PluginObject<any> = {
  install(Vue) {
    Vue.filter('dateHijriSuffix', (value:string) => `${value} ${i18n.t('hijriDateSuffix')}`);
    Vue.filter('dateGeorgianSuffix', (value:string) => `${value} ${i18n.t('georgianDateSuffix')}`);
  },

};
